import React from 'react';
import { type PropsWithChildren } from 'react';

import { BodyText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesDescription = (props: PropsWithChildren) => {
  const { children } = props;

  return <BodyText sizeMatch={['16']}>{children}</BodyText>;
};
